import {useState} from 'react'
import {InputApi, InputProps, InputValidationType} from './types'

type UseInputProps = Pick<
  InputProps,
  | 'onClick'
  | 'onSubmit'
  | 'onCancel'
  | 'onBlur'
  | 'onChange'
  | 'onFocus'
  | 'onInit'
  | 'isValid'
  | 'type'
>

export const useInput = (props: UseInputProps) => {
  const [baseElement, setBaseElement] = useState<HTMLInputElement>()
  const [validationType, setValidationType] = useState<InputValidationType>()

  const api: InputApi = {baseElement, text: ''}

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (!isKeyValid(e, props)) {
      e.preventDefault()
      return
    }

    api.text = e.currentTarget.value
    if (e.key === 'Enter') {
      e.preventDefault()
      e.stopPropagation()
      props.onSubmit?.(api)
    } else if (e.key === 'Escape') {
      e.preventDefault()
      e.stopPropagation()
      props.onCancel?.(api)
    }
  }
  const onFocus = (e: React.FocusEvent<HTMLInputElement>): void => {
    api.text = e.currentTarget.value
    props.onFocus?.(api)
  }
  const onBlur = (e: React.FocusEvent<HTMLInputElement>): void => {
    api.text = e.currentTarget.value
    props.onBlur?.(api)
  }
  const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (props.type === 'number') {
      handleNumberValueIsInvalid(e)
    }

    api.text = e.currentTarget.value
    props.onChange?.(api)
    props.isValid && setValidationType(props.isValid(api.text))
  }
  const ref = (el?: HTMLInputElement): void => {
    if (!el) {
      return
    }
    setBaseElement(el)
    props.onInit?.(el)
    props.isValid && setValidationType(props.isValid(api.text))
  }
  const onClick = (): void => {
    props.onClick?.()
  }

  return {onKeyDown, onFocus, onBlur, onChange, onClick, ref, validationType}
}

const isKeyValid = (
  e: React.KeyboardEvent<HTMLInputElement>,
  props: UseInputProps
): boolean => {
  if (props.type === 'number') {
    return !/^[eE]$/.test(e.key)
  }

  return true
}

const handleNumberValueIsInvalid = (
  e: React.ChangeEvent<HTMLInputElement>
): void => {
  if (e.target?.validity?.badInput) {
    e.target.value = ''
  }
}
